(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('ContractGridDTO', ContractGridDTO);

    ContractGridDTO.$inject = ['$resource','DateUtils'];

    function ContractGridDTO($resource, DateUtils) {
        var resourceUrl = "api/contractGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.contractDate = DateUtils.convertLocalDateFromServer(data.contractDate);
                    }
                    return data;
                }
            }
        });
    }
})();
